import * as actionTypes from "../actionTypes";
import { orderInfo, orderType } from "../reducers/order";

export const setOrderDetails = (details: Partial<orderType>) => {
  return {
    type: actionTypes.SET_ORDER_DETAILS,
    payload: details
  };
};

export const clearOrderDetails = () => ({
  type: actionTypes.CLEAR_ORDER_DETAILS
});

export const setOrderInfo = (info: orderInfo) => ({
  type: actionTypes.SET_ORDER_INFO,
  payload: info
});

export const setPaymentSuccess = (data: boolean) => ({
  type: actionTypes.SET_PAYMENT_SUCCESS,
  payload: data
});

export const setDirectPayment = (data: boolean) => ({
  type: actionTypes.DIRECT_PAYMENT,
  payload: data
});
